import { Row } from '@unistocks/components/layout/flex';
import { H5 } from '@unistocks/components/text/text';
import React from 'react';
import { ThemeableStack, ViewProps } from 'tamagui';

export type ChartHeaderProps = ViewProps & {
  heading?: string;
};

export const ChartHeader: React.FC<ChartHeaderProps> = ({ heading, children, ...props }) => {
  return (
    <ThemeableStack
      bg={'$color4'}
      br={'$true'}
      py={'$1.5'}
      px={'$3'}
      w={'100%'}
      alignSelf="center"
      $sm={{ w: 'auto' }}
      {...props}
    >
      {heading ? (
        <H5 color={'$color'} fontWeight={'$8'} alignSelf={'center'} userSelect="none">
          {heading}
        </H5>
      ) : null}

      <Row justifyContent="space-between" flexWrap="wrap" gap={'$3'}>
        {children}
      </Row>
    </ThemeableStack>
  );
};
